<template>
  <v-dialog v-model="dialog" max-width="600px">
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("StockOrderIN.DetailFields.title") }}
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          {{ $t("$vuetify.close") }}
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-4 py-8 text-center subtitle-1">
        <v-data-table
          :headers="headers"
          :items="errorData"
          multi-sort
          class="elevation-0 px-4 pt-2"
          disable-pagination
          hide-default-footer
          fixed-header
        >
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="secondary" outlined @click="dialog = false">
          {{ $t("$vuetify.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

import {mapState} from "vuex";
import i18n from "@/i18n";

export default {
  name: "DialogDateError",

  props: {
    value: Boolean,
    errorData: Array,
  },
  computed: {
    headers: () => [
      {
        text: i18n.t("StockOrderIN.DetailFields.category"),
        align: "start",
        sortable: false,
        value: "category_name",
      },
      {
        text: i18n.t("StockOrderIN.DetailFields.material_code"),
        align: "center",
        sortable: false,
        value: "material_code",
      },
      {
        text: i18n.t("StockOrderIN.DetailFields.material_name"),
        align: "end",
        sortable: false,
        value: "material_name",
      },
    ],
    ...mapState(["loading", "settings"]),
  },
  data: () => ({
    dialog: false,
  }),
  methods: {
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = this.value;
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
      },
    },
  },
};
</script>